<template>
  <div class="footer" id="footer">
    <div class="footer_content">
      <div class="content_left">
        <MapContainer></MapContainer>
        <div>
          <div class="mt_5">联系电话：021-39910155</div>
          <div class="mt_5">手机号码：18016395506</div>
          <div class="mt_5">邮箱：CCGJ@sanyehe.cn</div>
          <div class="mt_5">地址：上海市嘉定区城北路378号鼎固商业中心</div>
        </div>
      </div>
      <div class="content_right">
        <el-form :model="contactForm" ref="contactForm" :rules="rules" label-width="80px">
          <el-form-item label="您的姓名" prop="name">
            <el-input v-model="contactForm.name" placeholder="请输入您的姓名" clearable></el-input>
          </el-form-item>
          <el-form-item label="联系方式" prop="phone">
            <el-input v-model="contactForm.phone" placeholder="请留下您的联系方式" clearable></el-input>
          </el-form-item>
          <el-form-item label="联系地址" prop="province" class="address">
            <el-select v-model="contactForm.province" placeholder="请选择省" @change="provinceChange" clearable>
              <el-option
                v-for="item in provinceList"
                :key="item.key"
                :label="item.value"
                :value="item.key">
              </el-option>
            </el-select>
            <el-select v-model="contactForm.city" placeholder="请选择市" clearable>
              <el-option
                v-for="item in cityList"
                :key="item.key"
                :label="item.value"
                :value="item.key">
              </el-option>
            </el-select>
            <el-input v-model="contactForm.address" placeholder="请输入详细地址" clearable></el-input>
            <!-- <el-input v-model="contactForm.address" placeholder="请输入您的联系地址" clearable></el-input> -->
          </el-form-item>
          <el-form-item label="内容" prop="remark">
            <el-input v-model="contactForm.remark" :autosize="{ minRows: 4}" placeholder="我能为您做什么" clearable type="textarea"></el-input>
          </el-form-item>
          <div class="submit_button" @click="submitFunc">提交</div>
        </el-form>
      </div>
      <div class="bottom_info">
        <a href="https://beian.miit.gov.cn/#/Integrated/index" target="_black">沪ICP备2023013436号-2</a>
      </div>
    </div>
  </div>
</template>

<script>
import MapContainer from '../components/MapContainer/MapContainer.vue'

export default {
  name: 'Footer',
  components: {
    MapContainer
  },
  data() {
    const valCheck = (rule, value, callback) => {
      if(value === "" || value === null) {
        callback(new Error('请选择省份'))
      } else if(this.contactForm.city === '' || this.contactForm.city === null) {
        callback(new Error('请选择市'))
      } else {
        callback()
      }
    }
    return {
      contactForm: {
        name: '',
        phone: '',
        province: '',
        city: '',
        address: '',
        remark: '',
      },
      provinceList: [],
      cityList: [],
      rules: {
        name: [{ required: true, message: "请输入姓名", trigger: "blur" }],
        phone: [{ required: true, message: "请输入联系方式", trigger: "blur" }],
        province: [{ required: true, validator: valCheck, trigger: "change" }],
        remark: [{ required: true, message: "请输入内容", trigger: "blur" }]
      }
    }
  },
  mounted() {
    this.queryProvince()
  },
  methods: {
    queryProvince() {
      this.$axios({
        method: 'get',
        url: 'https://chaichegj.cn:9015/sys/area/getProvinceSelects',
        headers: {
          'Content-Type': 'application/json;charset=utf-8',
        },
      }).then(res => {
        this.provinceList = res.data.result
      })
    },
     provinceChange(e) {
      this.contactForm.city = ''
      if(e) {
        this.$axios({
          method: 'get',
          url: 'https://chaichegj.cn:9015/sys/area/getCitySelects',
          headers: {
            'Content-Type': 'application/json;charset=utf-8',
          },
          params: {
            id: e
          }
        }).then(res => {
          this.cityList = res.data.result
        })
      }
    },
    submitFunc() {
      // if(!this.contactForm.province || !this.contactForm.city) {
      //   this.$message({ message: '请完善城市信息', type: 'warning' })
      //   return
      // }
      const reg = /^1(3\d|4[5-9]|5[0-35-9]|6[567]|7[0-8]|8\d|9[0-35-9])\d{8}$/
      if(reg.test(this.contactForm.phone) === false) {
        this.$message({ message: '请输入正确的手机号', type: 'warning' })
        return
      }
      this.$refs.contactForm.validate(valid => {
        if(valid) {
          this.$axios({
            method: 'post',
            url: 'https://chaichegj.cn:9015/sys/indexForm/addJoinForm',
            headers: {
              'Content-Type': 'application/json;charset=utf-8',
            },
            data: JSON.stringify({
              ...this.contactForm,
              type: '2'
            })
          }).then(res => {
            if(res.data.appCode === "S0000") {
              this.$message({ message: '提交成功！', type: 'success' })
              this.resetFunc()
            }
          })
        }
      })
    },
    resetFunc() {
      this.contactForm = {
        name: '',
        phone: '',
        province: '',
        city: '',
        address: '',
        remark: '',
      }
      this.$refs.contactForm.clearValidate()
    }
  }
}
</script>

<style scoped>
.footer {
  height: calc(100vh - 300px);
  background-color: #2556a5;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
}
.footer_content {
  width: 85%;
  /* height: 100%; */
  display: flex;
  justify-content: space-around;
}
.content_left {
  color: #fff;
}
.mt_5 {
  margin-top: 8px;
}
::v-deep .el-form-item__label {
  color: #fff;
}
::v-deep .el-input--suffix {
  width: 450px;
}
.address ::v-deep .el-input--suffix{
  width: 150px;
}
.submit_button {
  width: 100px;
  text-align: center;
  padding: 10px 50px;
  margin-left: 80px;
  background-color: #02b2b5;
  color: #fff;
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.bottom_info {
  width: 100%;
  position: absolute;
  bottom: 5px;
  font-size: 12px;
  display: flex;
  justify-content: center;
}
a {
  color: #fff;
  text-decoration: none;
}
@media screen and (max-width: 1366px) {
  .footer {
    height: calc(100vh - 100px);
  }
}
</style>